module.exports = __webpack_public_path__ + "site/img/doc.68477983.png";